import React from "react";
import "./exam-doc.scss";

const Criteria = () => {
  return (
    <div className="exam-doc p-6 max-w-5xl mx-auto text-gray-900 leading-relaxed space-y-4">
      <h1 className="text-2xl font-bold text-center">
        Нийтлэг шалгуур
      </h1>
      <p>
        Эрүүл мэндийн сайдын 2019 оны 11 сарын 15-ны өдрийн А/513 дугаар тушаалын 1 дүгээр
        хавсралтын дагуух мэргэшлийн зэрэг горилогчид тавигдах нийтлэг шаардлага.
      </p>

      <h2 className="text-xl font-semibold mt-4">Мэргэшлийн зэрэг горилогчид тавигдах нийтлэг шаардлага</h2>

      <h3 className="font-semibold">“Ахлах” зэрэг горилогч эмнэлгийн мэргэжилтэн дараах нийтлэг шаардлагыг хангасан байна. Үүнд:</h3>
      <ul className="list-disc ml-6 space-y-1">
        <li>Мэргэшлийн зэрэг горилж буй чиглэлээр мэргэжлийн диплом эсхүл үндсэн мэргэшлийн үнэмлэхтэй байх;</li>
        <li>Тухайн мэргэжил эсхүл тухайн үндсэн мэргэшлийн чиглэлээр 8-аас доошгүй жил тасралтгүй ажилласан байх,</li>
        <li>Сум, тосгон, өрхийн эрүүл мэндийн төв, сум дундын эмнэлэгт ажиллаж буй эмнэлгийн мэргэжилтний хувьд тухайн мэргэжил эсхүл тухайн үндсэн мэргэшлийн чиглэлээр 6-аас доошгүй жил тасралтгүй ажилласан байх;</li>
        <li>Ажиллаж буй байгууллагаас тухайн мэргэжил, үндсэн мэргэшлийн чиглэлээр мэргэшлийн зэрэг горилохыг дэмжсэн байх;</li>
        <li>Мэргэжлийн үйл ажиллагаа эрхлэх хүчин төгөлдөр зөвшөөрөлтэй байх (мэргэжлийн үйл ажиллагаа эрхлэх зөвшөөрөл шаардагдах мэргэжилд хамаарна);</li>
        <li>Жил тутам биелүүлсэн багц цагийн сургалтын 2/3-оос доошгүй нь тухайн ажиллаж буй мэргэжил, үндсэн мэргэшлийн чиглэлээр байх;</li>
        <li>Тухайн мэргэжил, үндсэн мэргэшлээр ажилласан сүүлийн 3 жилийн хугацаанд ёс зүйн болон мэргэжлийн алдаа гаргаагүй байх.</li>
      </ul>

      <h3 className="font-semibold">“Тэргүүлэх” зэрэг горилогч эмнэлгийн мэргэжилтэн нь дараах нийтлэг шаардлагыг хангасан байна. Үүнд:</h3>
      <ul className="list-disc ml-6 space-y-1">
        <li>Мэргэшлийн зэрэг горилж буй чиглэлээр мэргэжлийн диплом эсхүл мэргэшлийн үнэмлэхтэй байх;</li>
        <li>Тухайн мэргэжил эсхүл тухайн мэргэшлийн чиглэлээр 13-аас доошгүй жил тасралтгүй ажилласан байх,</li>
        <li>Сум, тосгон, өрхийн эрүүл мэндийн төв, сум дундын эмнэлэгт ажиллаж буй эмнэлгийн мэргэжилтний хувьд тухайн мэргэжил эсхүл тухайн үндсэн мэргэшлийн чиглэлээр 10-аас доошгүй жил тасралтгүй ажилласан байх;</li>
        <li>Ажиллаж буй байгууллагаас тухайн мэргэжил, мэргэшлийн чиглэлээр мэргэшлийн зэрэг горилохыг дэмжсэн байх,</li>
        <li>Орон нутагт ажиллаж буй эмнэлгийн мэргэжилтний тухайд харьяалах Эрүүл мэндийн газраас тухайн мэргэжил, мэргэшлийн чиглэлээр мэргэшлийн зэрэг горилохыг дэмжсэн байх;</li>
        <li>Мэргэжлийн үйл ажиллагаа эрхлэх хүчин төгөлдөр зөвшөөрөлтэй байх (мэргэжлийн үйл ажиллагаа эрхлэх зөвшөөрөл шаардагдах мэргэжилд хамаарна);</li>
        <li>Байгууллага болон бүс, орон нутгийн хэмжээнд сургалтад оролцох, зохион байгуулах, үр дүнд хүрсэн байх;</li>
        <li>Жил тутам биелүүлсэн багц цагийн сургалтын 2/3-оос доошгүй нь тухайн мэргэжил, мэргэшлийн чиглэлээр байх;</li>
        <li>Сүүлийн 3 жилд ёс зүйн болон мэргэжлийн алдаа гаргаагүй байх.</li>
      </ul>

      <h3 className="font-semibold">“Зөвлөх” зэрэг горилогч эмнэлгийн мэргэжилтэн нь дараах нийтлэг шаардлагыг хангана. Үүнд:</h3>
      <ul className="list-disc ml-6 space-y-1">
        <li>Мэргэшлийн зэрэг горилж буй чиглэлээр мэргэжлийн диплом эсхүл мэргэшлийн үнэмлэхтэй байх;</li>
        <li>Тухайн чиглэлээр 25-аас доошгүй жил тасралтгүй ажилласан байх;</li>
        <li>Сувилагчийн хувьд 20-аас доошгүй жил тасралтгүй ажилласан байх;</li>
        <li>Байгууллага болон Эрүүл мэндийн газар дэмжсэн байх;</li>
        <li>Мэргэжлийн үйл ажиллагаа эрхлэх хүчин төгөлдөр зөвшөөрөлтэй байх;</li>
        <li>Бүс, үндэсний хэмжээнд сургалт зохион байгуулсан, оролцсон байх;</li>
        <li>Жил тутам биелүүлсэн багц цагийн 2/3-оос доошгүй нь тухайн чиглэлээр байх;</li>
        <li>Сүүлийн 5 жилд ёс зүйн болон мэргэжлийн алдаа гаргаагүй байх;</li>
        <li>Салбарын хөгжилд хувь нэмэр оруулсан манлайлагч байх.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6">Тусгай шалгуур</h2>
      <p className="exam-doc__attachment-ref">
        Хавсралт 2.{"\n"}
        Арьс, харшил судлалын мэргэжлийн{"\n"}
        салбар зөвлөлийн 2026 оны 03 дугаар{"\n"}
        сарын 13-ны өдрийн 03 дугаар хурлын{"\n"}
        шийдвэрийг үндэслэн
      </p>

      <h3 className="font-semibold mt-4">
        “Ахлах” зэрэг горилогч эмнэлгийн мэргэжилтэн нь дараах тусгай шаардлагыг хангасан байна. Үүнд:
      </h3>
      <ol className="list-decimal ml-6 space-y-3">
        <li>
          Тасралтгүй суралцагч байх. Дор дурдсанаас аль нэгийг нотлох баримтаар ирүүлэх:
          <ol className="list-decimal ml-6 mt-1 space-y-1" type="a">
            <li>Багц цагийн 12 кредитээс доошгүй сургалтад суусан байх</li>
            <li>Төгсөлтийн дараах мэргэжил дээшлүүлэх сургалтад сурсан байх</li>
            <li>
              Гадаад сургалтын байгууллага, эмнэлэгт эмнэлзүйн чиглэлээр богино хугацааны сургалтад
              хамрагдаж мэргэжил дээшлүүлсэн байх
            </li>
          </ol>
        </li>
        <li>
          Эмнэлзүйн туршлага хуримтлуулсан асуудлыг бие даан шийдвэрлэх чадвартай байх. Дор дурдсан
          нотлох баримтыг ирүүлэх:
          <ol className="list-decimal ml-6 mt-1 space-y-1" type="a">
            <li>
              Арьс судлалаар төрөлжсөн тусламж, үйлчилгээ үзүүлдэг, тусгай зөвшөөрөл бүхий эмнэлэгт
              арьсны эмчээр 4-с доошгүй жил ажилласан байх
            </li>
          </ol>
        </li>
        <li>
          Судлаач байх. Дор дурдсанаас аль нэгийг нотлох баримтаар ирүүлэх:
          <ol className="list-decimal ml-6 mt-1 space-y-1" type="a">
            <li>
              Нэгдүгээр зохиогч эсхүл хариуцлагатай зохиогчоор илтгэл танилцуулсан эсхүл өгүүлэл
              хэвлүүлсэн байх
            </li>
            <li>Дотоодын сэтгүүлд хамтарсан зохиогчоор 3-аас доошгүй бүтээл хэвлүүлсэн байх</li>
            <li>
              Олон улсын хуралд аман эсхүл ханын илтгэл хэлэлцүүлж эсхүл бүтээлийн хураангуй илгээж
              оролцсон байх.
            </li>
          </ol>
        </li>
      </ol>

      <h3 className="font-semibold mt-6">
        “Тэргүүлэх” зэрэг горилогч эмнэлгийн мэргэжилтэн нь дараах тусгай шаардлагыг хангасан байна.
        Үүнд:
      </h3>
      <ol className="list-decimal ml-6 space-y-3">
        <li>
          Тасралтгүй суралцагч байх. Дор дурдсанаас аль нэгийг нотлох баримтаар ирүүлэх. Ахлах зэрэг
          авснаас хойш
          <ol className="list-decimal ml-6 mt-1 space-y-1" type="a">
            <li>
              Мэргэжлийн чиглэлээр 10 кредитээс доошгүй сургалтад суусан эсхүл заасан байх
            </li>
            <li>
              Гадаад сургалтын байгууллага, эмнэлэгт эмнэлзүйн чиглэлээр 1 сараас доошгүй хугацаагаар
              мэргэжил дээшлүүлсэн байх
            </li>
          </ol>
        </li>
        <li>
          Эмнэлзүйн ховор тохиолдлыг дангаар юм уу багаар шийдвэрлэх туршлагатай бусдад мэргэжлийн
          зөвлөгөө өгөх, зааж сургах, байгууллагын асуудлыг цогцоор харж зохион байгуулах, баг удирдах
          чадвартай байх. Дор дурдсан нотлох баримтыг ирүүлэх:
          <ol className="list-decimal ml-6 mt-1 space-y-1" type="a">
            <li>
              Арьс судлалаар төрөлжсөн тусламж, үйлчилгээ үзүүлдэг, тусгай зөвшөөрөл бүхий эмнэлэгт
              арьсны эмчээр 8-аас доошгүй жил ажилласан байх
            </li>
          </ol>
        </li>
        <li>
          Судлаач байх. Дор дурдсанаас аль нэгийг нотлох баримтаар ирүүлэх. Ахлах зэрэг авснаас хойш:
          <ol className="list-decimal ml-6 mt-1 space-y-1" type="a">
            <li>
              Эмнэлзүйн ховор тохиолдол, эмнэлзүйн судалгаа... гм хийж нэгдүгээр зохиогч эсхүл
              хариуцлагатай зохиогчоор илтгэл танилцуулсан эсхүл өгүүлэл хэвлүүлсэн байх
            </li>
            <li>Дотоодын сэтгүүлд хамтарсан зохиогчоор 3-аас доошгүй бүтээл хэвлүүлсэн байх</li>
            <li>
              Олон улсын хуралд аман эсхүл ханын илтгэл хэлэлцүүлж эсхүл бүтээлийн хураангуй илгээж
              оролцсон байх
            </li>
          </ol>
        </li>
      </ol>

      <h3 className="font-semibold mt-6">
        “Зөвлөх” зэрэг горилогч эмнэлгийн мэргэжилтэн нь дараах тусгай шаардлагыг хангасан байна. Үүнд:
      </h3>
      <ol className="list-decimal ml-6 space-y-3">
        <li>
          Манлайлагч байх. Дор дурдсанаас аль нэгийг нотлох баримтаар ирүүлэх:
          <ol className="list-decimal ml-6 mt-1 space-y-1" type="a">
            <li>
              Арьс судлалын чиглэлээр мэргэжил арга зүйн бодлогын баримт, бичиг боловсруулах батлуулахад
              5-аас дээш удаа оролцсон байх
            </li>
            <li>
              Мэргэжлийн чиглэлээр 1-ээс доошгүй ном, сурах бичиг хэвлүүлсэн эсхүл 2-оос доошгүй
              номын бүлэг бичиж хэвлүүлсэн байх
            </li>
          </ol>
        </li>
        <li>
          Ментор байх. Эмнэлзүйн ховор тохиолдлыг бие даан эсхүл олон мэргэжлийн багаар шийдвэрлэх
          чадвартай, салбарын асуудлыг цогцоор нь харж хөгжүүлэх чиглэлээр идэвх санаачилгатай ажилласан
          байх. Дор дурдсан нотлох баримтыг ирүүлэх:
          <ol className="list-decimal ml-6 mt-1 space-y-1" type="a">
            <li>
              Залуу эмч мэргэжилтнүүдийг дагалдуулан дадлагажуулах, мэргэжил арга зүйгээр хангаж ажилласан
              байх
            </li>
            <li>Мэргэжлийн салбар зөвлөлд ажилласан байх</li>
            <li>Эмнэлзүйн сургагч багш байх</li>
          </ol>
        </li>
        <li>
          Судлаач байх. Дор дурдсанаас аль нэгийг нотлох баримтаар ирүүлэх:
          <ol className="list-decimal ml-6 mt-1 space-y-1" type="a">
            <li>
              Нэгдүгээр зохиогч эсхүл хариуцлагатай зохиогчоор 3-аас доошгүй илтгэл танилцуулсан эсхүл
              өгүүлэл хэвлүүлсэн байх
            </li>
            <li>Дотоодын сэтгүүлд хамтарсан зохиогчоор 5-аас доошгүй бүтээл хэвлүүлсэн байх</li>
            <li>
              Олон улсын хуралд аман эсхүл ханын илтгэл хэлэлцүүлж эсхүл бүтээлийн хураангуй 3-аас
              доошгүйг илгээж оролцсон байх
            </li>
          </ol>
        </li>
      </ol>
    </div>
  );
};

export default Criteria;

  